export const MuiDialogActions = () => ({
  root: {
    padding: '20px 30px 30px 30px'
  }
});
